import { Component, Injector, OnInit, inject } from '@angular/core';
import { MaterialModule, PageKind, UiModeType, jkLib, jkRestReturn, } from 'jk-service';
import { StkmjService, templateUrlConfigStk } from './../_service_stk';
//import { Stkpi17DetailComponent } from './stkpi17-detailPkg.component';
import { Stkpi17PkgComponent } from './stkpi17Pkg.component';
import { JackBaseComponentModule } from 'jk-service';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-stkpi17',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
    //Stkpi17DetailComponent,
  ],
  templateUrl: templateUrlConfigStk.stkpi17,
  styleUrls: [],
})
export class Stkpi17Component extends Stkpi17PkgComponent implements OnInit {
  override _programId = 'stkpi17';
  constructor() {
    super();
    this.qbeConfig.addField = 'MJ003,MJ005,MJ007';
  }


  dateA: string = this.nowDate();
  dateB: string = this.nowDate();
  group: string = '000';
  mj002List: any[] = [];
  doExecute() {
    let date = this.dateA;
    let mList: string = '';
    for (let i = 0; i < this.mj002List.length; i++) {
      mList = mList + this.iif(mList === '', '', ',') + this.mj002List[i].id;
    };
    while (date <= this.dateB) {
      //this.showLoadingView({showOverlay : true });
      let url = this.serverUrl + `/stock/calcSTKMJ?group=${this.group}&date=${date}&period=日線&time=1325&stkmjList=${mList}`;
      date = jkLib.countDate(date, 'D', 1);
      // http://localhost:9086/stock/calcSTKMJ?group=000&date=20240401&period=日線&time=1325&isStkmj=true&isStkmm=false&stocks&stkmjList=C03
      this.orm.http.get(url).subscribe((res: any) => {
        console.log(res);

        this.logMessage += res + '\n';
        //this.dismissLoadingView();
        this.cdr.markForCheck();
      });
    }// end while
  }
  /*
  doExecute() {
    if(this.stkme001){
      this.group = this.stkme001.value;
    }else
      this.group = '000';

    let mList: string = '';
    if(this.stkmj002){
      mList = this.stkmj002.commaValues();
    }
    // mList = this.mj002List.join(',');
    this.stockSrv.calcSTKMJ(this.group, this.dateA, this.dateB, '日線', '1325', mList).subscribe((res) => {
      this.logMessage += JSON.stringify(res) + '\n';
    });

  }*/
  doUpdateAll() {
    let url = this.serverUrl + `/stock/updateSTKMFstar`;
    this.logMessage += url + '\n';
    this.orm.http.get(url).subscribe((res: any) => {
      this.logMessage += JSON.stringify((res as jkRestReturn).obj) + '\n';
      this.cdr.markForCheck();
    });
  }
  stkmnUpdateAll() {
    let url = this.serverUrl + `/stock/stkmnUpdateAll`;
    this.logMessage += url + '\n';
    this.orm.http.get(url).subscribe((res: any) => {
      this.logMessage += JSON.stringify((res as jkRestReturn).log) + '\n';
      this.cdr.markForCheck();
    });
  }
  test() {
  }

}
